import PropTypes from 'prop-types'
import React from 'react'
import { CardImg, Col, Container, Row } from 'reactstrap'


const propTypes = {
  title : PropTypes.string,
  lead  : PropTypes.string,
  logo  : PropTypes.string
}

const PublicHeader = ({ title, lead, logo }) => (
  <div className="header py-7 py-lg-8 pt-lg-9"
    style={{ backgroundColor: '#8d9e74' }}
  >
    <Container>
      <div className="header-body text-center mb-3">
        <Row className="justify-content-center">
          <Col className="px-5" lg="6" md="8" xl="5">
              <div className='text-center mb-3'>
                  <CardImg src={ 'https://production.belleandkate.com/assets/room_logo_white-cd01eee5c4ab6d6fd7c1eb6ab315b2bda22d9799a0aeb38b47372a19f495b41f.png' }/>
                </div>
            {/* {
              logo ? (
                <div className='text-center mb-3'>
                  <CardImg src={ 'https://production.belleandkate.com/assets/room_logo_white-cd01eee5c4ab6d6fd7c1eb6ab315b2bda22d9799a0aeb38b47372a19f495b41f.png' }/>
                </div>
              )
                : null
            } */}

            {/* { title ? (
              <h1 className="text-white">{ title }</h1>
            ) : null }
            { lead ? (
              <p className="text-lead text-white">{ lead }</p>
            ) : null } */}
          </Col>
        </Row>
      </div>
    </Container>

  </div>
)

PublicHeader.propTypes = propTypes

export default PublicHeader
